import React, { Children, forwardRef } from 'react'

import styled, { defaultAttrs } from '@/styles'

import { Box, BoxProps } from './Box'
import { AdaptiveValue, direction, full, spacing, sx } from './styledUtils'

export type SpacerProps = BoxProps

export const Spacer = styled(Box).attrs<SpacerProps>((p) =>
	defaultAttrs(p, {
		flex: '1',
	}),
)``

Spacer.displayName = 'Spacer'

type StackBoxProps = BoxProps & {
	// The current MUI version has no types on the system properties
	direction?: AdaptiveValue<NonNullable<React.CSSProperties['flexDirection']>>
	spacing?: AdaptiveValue<NonNullable<React.CSSProperties['gap']>>
}

/**
 * We are not wrapping a Box to squeeze some additional performance
 */
const StackBox = styled.div<StackBoxProps>`
	display: flex;
	flex-direction: column;
	${full}
	${sx}
	${direction}
 	${spacing}
`

StackBox.displayName = 'StackBox'

/**
 * @deprecated Use MUI
 */
export type StackProps = StackBoxProps & {
	divider?: React.ReactNode
}

/**
 * @deprecated Use MUI
 * Remove after upgrading to MUI v5.
 */
export const Stack = forwardRef<HTMLDivElement, StackProps>(({ children, divider, ...rest }, ref) => {
	return (
		<StackBox
			ref={ref}
			{...rest}
			{...(rest.onClick ? { role: 'button', tabIndex: 0, style: { ...(rest.style ?? {}), cursor: 'pointer' } } : {})}
		>
			{divider
				? Children.map(children, (child, index) =>
						child ? (
							<React.Fragment>
								{index > 0 ? (divider as React.ReactElement) : null}
								{child as React.ReactNode}
							</React.Fragment>
						) : null,
					)
				: children}
		</StackBox>
	)
}) as React.ForwardRefFix<HTMLDivElement, StackProps>

Stack.displayName = 'Stack'
